<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getLabelTitleErrorMessage } from './validations';
import { getRandomColor } from 'dashboard/helper/labelColor';
import { useVuelidate } from '@vuelidate/core';

import LabelForm from './LabelForm.vue';

export default {
  components: {
    LabelForm,
  },
  props: {
    prefillTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      color: '#000',
      description: '',
      title: '',
      showOnSidebar: true,
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'labels/getUIFlags',
    }),
    labelTitleErrorMessage() {
      const errorMessage = getLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.color = getRandomColor();
    this.title = this.prefillTitle.toLowerCase();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async addLabel() {
      try {
        await this.$store.dispatch('labels/create', {
          color: this.color,
          description: this.description,
          title: this.title.toLowerCase(),
          show_on_sidebar: this.showOnSidebar,
        });
        useAlert(this.$t('LABEL_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('LABEL_MGMT.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex h-auto flex-col overflow-visible">
    <LabelForm
      v-model:title="title"
      v-model:description="description"
      v-model:color="color"
      v-model:show-on-sidebar="showOnSidebar"
      :header-title="$t('LABEL_MGMT.ADD.TITLE')"
      :header-description="$t('LABEL_MGMT.ADD.DESC')"
      :submit-label="$t('LABEL_MGMT.FORM.CREATE')"
      :title-error="labelTitleErrorMessage"
      :is-loading="uiFlags.isCreating"
      :submit-disabled="v$.title.$invalid || uiFlags.isCreating"
      @title-blur="v$.title.$touch"
      @submit="addLabel"
      @cancel="onClose"
    />
  </div>
</template>
